export const NORTHBEAM_BREAKDOWNS = [
  "Category (Northbeam)",
  "Platform (Northbeam)",
  "Targeting (Northbeam)",
  "Revenue Source (Northbeam)",
];

export function breakdownComparator(a: string, b: string) {
  const nameA = a.toUpperCase();
  const nameB = b.toUpperCase();

  if (NORTHBEAM_BREAKDOWNS.includes(a) && NORTHBEAM_BREAKDOWNS.includes(b)) {
    if (nameA < nameB) {
      return -1;
    }

    if (nameA > nameB) {
      return 1;
    }

    return 0;
  }

  if (NORTHBEAM_BREAKDOWNS.includes(a)) {
    return -1;
  }

  if (NORTHBEAM_BREAKDOWNS.includes(b)) {
    return 1;
  }

  if (nameA < nameB) {
    return -1;
  }

  if (nameA > nameB) {
    return 1;
  }

  return 0;
}
